module.exports = __webpack_public_path__ + "4c47f6e33f5888341678bbd212400b6c.svg";